/** Built-in period types and group chips, from the plugin. */
import type { PeriodType } from '../types';

export const GROUPS = ['OL', 'DL', 'QB', 'RB', 'H', 'Y', 'Z', 'X', 'LB', 'DB', 'K/P', 'LS', 'All'];

export const BUILTIN_TYPES: PeriodType[] = [
  { code: 'WU', label: 'Warm Up', bg: '#3d8f5a', fg: '#fff', builtin: true },
  { code: 'OI', label: 'Offense Install', bg: '#1e5799', fg: '#fff', builtin: true },
  { code: 'DI', label: 'Defense Install', bg: '#6a2c91', fg: '#fff', builtin: true },
  { code: 'OG', label: 'Offense Group', bg: '#1e5799', fg: '#fff', builtin: true },
  { code: 'DG', label: 'Defense Group', bg: '#6a2c91', fg: '#fff', builtin: true },
  { code: 'OT', label: 'Offense Team', bg: '#c9a227', fg: '#1a1a16', builtin: true },
  { code: 'DT', label: 'Defense Team', bg: '#6a2c91', fg: '#fff', builtin: true },
  { code: 'ST', label: 'Special Teams', bg: '#e07b2a', fg: '#fff', builtin: true },
  { code: 'PP', label: 'Pre-Practice', bg: '#4a4a44', fg: '#fff', builtin: true },
  { code: 'GS', label: 'Game Situation', bg: '#2c5364', fg: '#fff', builtin: true },
  { code: 'C', label: 'Conditioning', bg: '#c0392b', fg: '#fff', builtin: true },
  { code: 'Water', label: 'Water Break', bg: '#3498db', fg: '#fff', builtin: true },
  { code: 'EOWO', label: 'End of Workout', bg: '#4a4a44', fg: '#fff', builtin: true },
];

export const TYPE_COLORS = ['#3d8f5a', '#1e5799', '#6a2c91', '#c9a227', '#e07b2a', '#4a4a44', '#2c5364', '#c0392b', '#3498db', '#8e44ad', '#16a085', '#d35400'];

export function getAllTypes(custom: PeriodType[], hiddenBuiltins: string[]): PeriodType[] {
  const hidden = new Set(hiddenBuiltins);
  return [...BUILTIN_TYPES.filter((t) => !hidden.has(t.code)), ...custom];
}

export function getType(code: string, custom: PeriodType[], hiddenBuiltins: string[]): PeriodType {
  return (
    getAllTypes(custom, hiddenBuiltins).find((t) => t.code === code) ||
    BUILTIN_TYPES.find((t) => t.code === code) ||
    { code, label: code, bg: '#4a4a44', fg: '#fff' }
  );
}
